module.exports = __webpack_public_path__ + "static/media/coreProducts.a0acf413.png";